import { NgModule } from '@angular/core';
import { SidebarComponent } from '../core/components/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';

@NgModule({
  declarations: [SidebarComponent, NoDataFoundComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatExpansionModule,
    RouterModule,
    MatSlideToggleModule
  ],
  exports: [SidebarComponent, NoDataFoundComponent]
})
export class AfterLoginSharedModule {}
